// a listener for video player (currently VimeoPlayer) which
// adds or removes scoops for watching a video
class RewardVideoListener {
	constructor(rewardTimeSpan, rewardUrl) {
		this.rewardTimeSpan = rewardTimeSpan;
		this.rewardUrl = rewardUrl;
		this.previousSeconds = 0;
		this.secondsCounter = 0;
	}

	onPlayProgress(currentSeconds) {
		var difference = currentSeconds - this.previousSeconds;
		// progress only counts if the user does not skip ahead or backward
		if (difference > 0 && difference < 5) {
			this.secondsCounter += difference;
			if (this.secondsCounter >= this.rewardTimeSpan) {
				this.secondsCounter = 0;
				axios(this.rewardUrl, {
					method: 'get'
				});
			}
		}
		this.previousSeconds = currentSeconds;
	}

	onLoadProgress(percentage) {
		// do nothing
	}

	onPlay() {
		// do nothing
	}

	onPause() {
		// do nothing
	}

	onEnd() {
		// do nothing
	}
}
